<template>
  <div class="league-analysis-view">
    <h2>联赛分析</h2>
    <p class="description">This section displays pre-generated visualization reports for each team.</p>

    <div v-if="teamVisuals.length" class="visuals-container">
      <div v-for="team in teamVisuals" :key="team.team_name" class="team-visual-card">
        <h3>{{ team.team_name }}</h3>
        <iframe :src="team.team_data_url" width="100%" height="500px" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script setup>
const files = import.meta.glob("@/assets/team_data_html/*.html", { eager: true, as:'url' });

const teamVisuals = Object.keys(files).map(path => {
  const filename = path.split("/").pop();
  return {
    team_name: filename.replace("_goals_vs_assists.html", "").replace(/_/g, " "),
    // 打包后会映射成正确的 URL
    team_data_url: files[path]
  };
});
</script>

<style scoped>
.league-analysis-view { padding: 20px; }
.description { color: #666; margin-bottom: 20px; }
.visuals-container { display: grid; grid-template-columns: repeat(auto-fill, minmax(600px, 1fr)); gap: 20px; }
.team-visual-card { border: 1px solid #ddd; border-radius: 8px; padding: 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
.team-visual-card h3 { margin-top: 0; margin-bottom: 10px; }
iframe { border-radius: 5px; }
</style>